/** Забежка закрыта — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { RunEndedView } from "./view";
import { registerWindow } from "../../../app";
import { actions } from "../actions";

export function RunEnded({ route, close }: WindowProps<"runEnded">) {
  return (
    <RunEndedView
      rejected={route.rejected ?? false}
      onFight={() => {
        actions().nextWave();
        close();
      }}
    />
  );
}

export function register(): void {
  registerWindow("runEnded", RunEnded);
}
